export default "__VITE_ASSET__E8wuXQ_AmxPT2QBGX_$9Vw__ 480w, __VITE_ASSET__pADEGV0e5Qot5ZhzD_GrLg__ 768w, __VITE_ASSET__7PUm3F_uVf$21BIFLSklvQ__ 1200w";